import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./CrearCliente.css";
import ModalArchivo from "./ModalArchivo";
import { API_URL } from "../config";
import { useCatalogos } from "../CONTEXTO/CatalogosContext";


export default function CrearCliente({ mode = "create" }) {
  const { id } = useParams();
  const clienteId = id || null;
  const navigate = useNavigate();
  // ============================
  // ESTADO DE ARCHIVOS
  // ============================
  const [archivos, setArchivos] = useState({});
  const [archivosEliminar, setArchivosEliminar] = useState({});
  const [comprobantesBD, setComprobantesBD] = useState({});

  // ============================
  // MODO
  // ============================
  const esCrear = mode === "create";
  const esVer = mode === "view";
  const esEditar = mode === "edit";
  const soloLectura = esVer;
 

  // ============================
  // ESTADOS PRINCIPALES
  // ============================
  const [fase, setFase] = useState(1);
  const [idCliente, setIdCliente] = useState(clienteId);
  const [idGarantia, setIdGarantia] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [modal, setModal] = useState(null);
  const [showModalGarantia, setShowModalGarantia] = useState(false);
  const mostrarFase2 = esCrear ? fase === 2 : true;
  

  // ============================
  // FORMULARIO CLIENTE
  // ============================
  const [form, setForm] = useState({
    Nombre: "",
    Apellido_Paterno: "",
    Apellido_Materno: "",
    Direccion: "",
    Codigo_postal: "",
    estado_id: "",
    ciudad_id: "",
    telefono: "",
    email: "",
    Ubicacion: "",
    Facebook: "",
    grupo_id: "",
    asesor_id: "",
    activo: 1,
    semaforo: "verde",
    tipo_cliente: "diario",
    credito_aceptado: ""
  });

  const updateForm = (name, value) => {
    if (!soloLectura) setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleChange = e => updateForm(e.target.name, e.target.value);

  const handleTelefono = e => {
    if (soloLectura) return;
    updateForm("telefono", e.target.value.replace(/[^0-9]/g, ""));
  };

  const handleCredito = e => {
    if (soloLectura) return;
    const raw = e.target.value.replace(/[^0-9]/g, "");
    const num = Number(raw);
    const formatted = num.toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0
    });
    updateForm("credito_aceptado", formatted);
  };

  // ============================
  // CATÁLOGOS
  // ============================
  const { estados, ciudades, grupos, asesores, cargados, cargarCatalogos } = useCatalogos();
  useEffect(() => {
    cargarCatalogos();   // ← ESTA ES LA CLAVE
  }, []);
  const [ciudadesFiltradas, setCiudadesFiltradas] = useState([]);
  // ============================
  // FILTRAR CIUDADES POR ESTADO
  // ============================
  useEffect(() => {
    if (form.estado_id && ciudades.length > 0) {
      setCiudadesFiltradas(
        ciudades.filter(c => c.estado_id == form.estado_id)
      );
    }
  }, [ciudades, form.estado_id]);

  // ============================
  // CP → ESTADO AUTOMÁTICO
  // ============================
  const handleCPChange = e => {
    if (soloLectura) return;

    const cp = e.target.value.replace(/[^0-9]/g, "");
    updateForm("Codigo_postal", cp);

    if (cp.length === 5) {
      const cpNum = Number(cp);
      const estado = estados.find(
        est => cpNum >= est.CP_min && cpNum <= est.CP_max
      );

      if (estado) {
        updateForm("estado_id", estado.id);
        updateForm("ciudad_id", "");
        setCiudadesFiltradas(ciudades.filter(c => c.estado_id === estado.id));
      }
    }
  };

  // ============================
  // ESTADO → CIUDADES
  // ============================
  const handleEstadoChange = e => {
    if (soloLectura) return;
    const estado_id = e.target.value;
    updateForm("estado_id", estado_id);
    updateForm("ciudad_id", "");
    setCiudadesFiltradas(ciudades.filter(c => c.estado_id == estado_id));
  };

  // ============================
  // ASESOR → GRUPO AUTOMÁTICO
  // ============================
  const handleAsesorChange = e => {
    if (soloLectura) return;
    const asesor_id = e.target.value;
    const asesor = asesores.find(a => a.id == asesor_id);
    updateForm("asesor_id", asesor_id);
    updateForm("grupo_id", asesor?.grupo_id || "");
  };

  // ============================
  // AVALES
  // ============================
  const parentescos = ["Madre", "Padre", "Herman@", "Ti@", "Prim@", "Amig@", "Espos@"];

  const [avales, setAvales] = useState({
    aval1: { nombre: "", parentesco: "", facebook: "", telefono: "" },
    aval2: { nombre: "", parentesco: "", facebook: "", telefono: "" }
  });

  const handleAvalChange = (e, key) => {
    if (soloLectura) return;
    setAvales(prev => ({
      ...prev,
      [key]: { ...prev[key], [e.target.name]: e.target.value }
    }));
  };

  const handleTelefonoAval = (e, key) => {
    if (soloLectura) return;
    const num = e.target.value.replace(/[^0-9]/g, "");
    handleAvalChange({ target: { name: "telefono", value: num } }, key);
  };

  // ============================
  // GARANTÍA
  // ============================
  const [garantia, setGarantia] = useState({ descripcion: "", serie: "" });

  // ============================
  // ARCHIVOS
  // ============================
  const handleModalComprobantesSave = (tipo, { nuevos, eliminar }) => {
    setArchivos(prev => {
      const prevValue = prev[tipo];

      // Normalizar: si NO es array, convertirlo en array
      const prevArray = Array.isArray(prevValue)
        ? prevValue
        : prevValue
        ? [prevValue]
        : [];

      return {
        ...prev,
        [tipo]: [...prevArray, ...(nuevos || [])]
      };
    });

    setArchivosEliminar(prev => ({
      ...prev,
      [tipo]: eliminar || []
    }));
    
  };
  // ============================
  // GUARDAR CLIENTE
  // ============================
  const guardarCliente = async () => {
    try {
      const token = localStorage.getItem("token");
      const creditoNumerico = Number(
        form.credito_aceptado.replace(/[^0-9]/g, "")
      );

      const payload = { ...form, credito_aceptado: creditoNumerico };
      const url = esEditar
        ? `${API_URL}/clientes/${clienteId}`
        : `${API_URL}/clientes`;
      const method = esEditar ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) return alert(data.error || "Error al guardar cliente");

      if (esCrear) {
        alert("Cliente guardado correctamente");
        setIdCliente(data.id_cliente);
        setFase(2);
      } else {
        alert("Cliente actualizado correctamente");
      }
    } catch (err) {
      console.error(err);
      alert("Error al guardar cliente");
    }
  };

 // ============================
  // GUARDAR COMPROBANTES AVALES (CORREGIDO)
  // ============================
  const guardarComprobantesAvales = async (idAval1, idAval2) => {
    try {
      const token = localStorage.getItem("token");

      for (const key in archivos) {
        // Solo claves de avales
        if (!key.startsWith("aval1_") && !key.startsWith("aval2_")) continue;

        // Normalizar arrays
        const nuevos = Array.isArray(archivos[key])
          ? archivos[key]
          : archivos[key]
          ? [archivos[key]]
          : [];

        const eliminar = Array.isArray(archivosEliminar[key])
          ? archivosEliminar[key]
          : [];

        // Determinar ID del aval
        let idAval = null;
        if (key.startsWith("aval1_")) idAval = idAval1;
        if (key.startsWith("aval2_")) idAval = idAval2;
        if (!idAval) continue;

        // Determinar tipo BD
        let tipoBD = "";
        if (key.includes("ine")) tipoBD = "ine";
        else if (key.includes("domicilio")) tipoBD = "domicilio";
        else continue;

        // 1) ELIMINAR COMPROBANTES EXISTENTES
        for (const idComprobante of eliminar) {
          await fetch(`${API_URL}/comprobantes/${idComprobante}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` }
          });

          // 🔥 quitarlo visualmente de comprobantesBD
          setComprobantesBD(prev => ({
            ...prev,
            [key]: (prev[key] || []).filter(c => c.Id_comprobante !== idComprobante)
          }));
        }

        // 2) SUBIR NUEVOS ARCHIVOS
        for (const file of nuevos) {
          if (!file) continue;

          // Solo subir si es File real
          if (file instanceof File) {
            const partes = file.name.split(".");
            const extension = partes.pop();
            const nombreSinExt = partes.join(".");
            const pesoKB = Math.round(file.size / 1024);

            // 2.1 pedir URL firmada
            const resUpload = await fetch(`${API_URL}/comprobantes/upload-url`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
              },
              body: JSON.stringify({
                Id_persona: idAval,
                Persona_tipo: "aval",
                tipo: tipoBD,
                extension
              })
            });

            const { provider_id, uploadUrl } = await resUpload.json();

            // 2.2 subir archivo a S3
            await fetch(uploadUrl, {
              method: "PUT",
              headers: { "Content-Type": "application/octet-stream" },
              body: file
            });

            // 2.3 confirmar en BD
            await fetch(`${API_URL}/comprobantes/confirmar`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
              },
              body: JSON.stringify({
                Id_persona: idAval,
                Persona_tipo: "aval",
                tipo: tipoBD,
                provider_id,
                Nombre_archivo: nombreSinExt,
                extension,
                peso_kb: pesoKB
              })
            });

            // 🔥 2.4 MOVER ARCHIVO NUEVO → EXISTENTE
            setComprobantesBD(prev => ({
              ...prev,
              [key]: [
                ...(prev[key] || []),
                {
                  Id_comprobante: provider_id,
                  Nombre_archivo: nombreSinExt,
                  extension,
                  peso_kb: pesoKB,
                  url: null,
                  provider_id
                }
              ]
            }));

            // 🔥 2.5 QUITARLO DE ARCHIVOS NUEVOS
            setArchivos(prev => ({
              ...prev,
              [key]: (prev[key] || []).filter(f => f !== file)
            }));
          }
        }
      }
    } catch (err) {
      console.error("Error guardando comprobantes de avales:", err);
    }
  };


  // ============================
  // GUARDAR AVALES
  // ============================
  const guardarAvales = async () => {
    try {
      const id = idCliente || clienteId;
      if (!id) return alert("Error: el cliente aún no tiene ID.");

      const token = localStorage.getItem("token");

      const payload = {
        avales: ["aval1", "aval2"].map(key => ({
          Nombre: avales[key].nombre,
          Parentesco: avales[key].parentesco,
          Facebook: avales[key].facebook,
          Telefono: avales[key].telefono,
          Direccion: "",
          relacion: ""
        }))
      };

      const res = await fetch(`${API_URL}/avales/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) return alert(data.error || "Error al guardar avales");

      // IDs reales (si existen)
      const idAval1 = data.avales[0]?.Id_avales || null;
      const idAval2 = data.avales[1]?.Id_avales || null;

      // Actualizar estado para UI
      setAvales(prev => ({
        ...prev,
        aval1: { ...prev.aval1, id: idAval1 },
        aval2: { ...prev.aval2, id: idAval2 }
      }));

      // Guardar comprobantes SOLO de los avales que existan
      await guardarComprobantesAvales(idAval1, idAval2);

      alert("Avales guardados correctamente");
    } catch (err) {
      console.error(err);
      alert("Error al guardar avales");
    }
  };

  // ============================
  // GUARDAR GARANTÍA
  // ============================
  const guardarGarantia = async () => {
    try {
      const id = idCliente || clienteId;
      if (!id) return alert("Primero guarda el cliente.");

      const token = localStorage.getItem("token");
      const payload = {
        descripcion: garantia.descripcion,
        serie: garantia.serie,
        cliente_id: id
      };

      const url = idGarantia
        ? `${API_URL}/garantias/${idGarantia}`
        : `${API_URL}/garantias`;
      const method = idGarantia ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) return alert(data.error || "Error al guardar garantía");

      setIdGarantia(data.id_garantia || idGarantia);
      alert("Garantía guardada correctamente");
    } catch (err) {
      console.error(err);
      alert("Error al guardar garantía");
    }
  };

  // ============================
  // GUARDAR COMPROBANTES CLIENTE (CORREGIDO)
  // ============================
  const guardarComprobantes = async () => {
    try {
      const token = localStorage.getItem("token");
      const id = idCliente || clienteId;
      if (!id) return alert("Error: el cliente aún no tiene ID.");

      for (const tipo in archivos) {

        // Normalizar arrays
        const nuevos = Array.isArray(archivos[tipo])
          ? archivos[tipo]
          : archivos[tipo]
          ? [archivos[tipo]]
          : [];

        const eliminar = Array.isArray(archivosEliminar[tipo])
          ? archivosEliminar[tipo]
          : [];

        // 1) ELIMINAR ARCHIVOS EXISTENTES
        for (const idComprobante of eliminar) {
          await fetch(`${API_URL}/comprobantes/${idComprobante}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` }
          });

          // También quitarlos visualmente
          setComprobantesBD(prev => ({
            ...prev,
            [tipo]: (prev[tipo] || []).filter(c => c.Id_comprobante !== idComprobante)
          }));
        }

        // 2) SUBIR ARCHIVOS NUEVOS
        for (const file of nuevos) {
          if (!file) continue;

          // Solo subir si es File real
          if (file instanceof File) {
            const partes = file.name.split(".");
            const extension = partes.pop();
            const nombreSinExt = partes.join(".");
            const pesoKB = Math.round(file.size / 1024);

            // 2.1 pedir URL firmada
            const resUpload = await fetch(`${API_URL}/comprobantes/upload-url`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
              },
              body: JSON.stringify({
                Id_persona: id,
                Persona_tipo: "cliente",
                tipo,
                extension
              })
            });

            const { provider_id, uploadUrl } = await resUpload.json();

            // 2.2 subir archivo a S3
            await fetch(uploadUrl, {
              method: "PUT",
              headers: { "Content-Type": "application/octet-stream" },
              body: file
            });

            // 2.3 confirmar en BD
            await fetch(`${API_URL}/comprobantes/confirmar`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
              },
              body: JSON.stringify({
                Id_persona: id,
                Persona_tipo: "cliente",
                tipo,
                provider_id,
                Nombre_archivo: nombreSinExt,
                extension,
                peso_kb: pesoKB
              })
            });

            // 🔥 2.4 MOVER ARCHIVO NUEVO → EXISTENTE
            setComprobantesBD(prev => ({
              ...prev,
              [tipo]: [
                ...(prev[tipo] || []),
                {
                  Id_comprobante: provider_id,
                  Nombre_archivo: nombreSinExt,
                  extension,
                  peso_kb: pesoKB,
                  url: null, // si tu backend no la devuelve aquí
                  provider_id
                }
              ]
            }));

            // 🔥 2.5 QUITARLO DE ARCHIVOS NUEVOS
            setArchivos(prev => ({
              ...prev,
              [tipo]: (prev[tipo] || []).filter(f => f !== file)
            }));
          }
        }
      }

      alert("Comprobantes guardados correctamente");
    } catch (err) {
      console.error(err);
      alert("Error al guardar comprobantes");
    }
  };


  // ============================
  // CARGAR CLIENTE (VIEW / EDIT)
  // ============================
  useEffect(() => {
    if (!(esVer || esEditar)) return;
    if (!clienteId) return;

    // Esperar catálogos (para selects)
    if (estados.length === 0 || ciudades.length === 0) return;
    if (!cargados) {
      return (
        <div className="crear-container">
          <p style={{ padding: "2rem", textAlign: "center" }}>
            Cargando catálogos...
          </p>
        </div>
      );
    }
    const cargarCliente = async (id) => {
      try {
        setCargando(true);
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const res = await fetch(`${API_URL}/clientes/${id}`, { headers });
        if (!res.ok) {
          alert("Error al cargar el cliente");
          return;
        }

        const data = await res.json();

        // ============================
        // CLIENTE
        // ============================
        const c = data.cliente;

        const creditoFormato = Number(c.credito_aceptado || 0).toLocaleString(
          "es-MX",
          { style: "currency", currency: "MXN", minimumFractionDigits: 0 }
        );

        setForm({
          Nombre: c.Nombre || "",
          Apellido_Paterno: c.Apellido_Paterno || "",
          Apellido_Materno: c.Apellido_Materno || "",
          Direccion: c.Direccion || "",
          Codigo_postal: c.Codigo_postal || "",
          estado_id: c.estado_id || "",
          ciudad_id: c.ciudad_id || "",
          telefono: c.telefono || "",
          email: c.email || "",
          Ubicacion: c.Ubicacion || "",
          Facebook: c.Facebook || "",
          grupo_id: c.grupo_id || "",
          asesor_id: c.asesor_id || "",
          activo: c.activo ?? 1,
          semaforo: c.semaforo || "verde",
          tipo_cliente: c.tipo_cliente || "diario",
          credito_aceptado: creditoFormato
        });

        if (c.estado_id) {
          setCiudadesFiltradas(
            ciudades.filter(ci => ci.estado_id === c.estado_id)
          );
        }

        // ============================
        // AVALES
        // ============================
        const avales = data.avales || [];

        setAvales({
          aval1: {
            nombre: avales[0]?.Nombre || "",
            parentesco: avales[0]?.Parentesco || "",
            facebook: avales[0]?.Facebook || "",
            telefono: avales[0]?.Telefono || ""
          },
          aval2: {
            nombre: avales[1]?.Nombre || "",
            parentesco: avales[1]?.Parentesco || "",
            facebook: avales[1]?.Facebook || "",
            telefono: avales[1]?.Telefono || ""
          }
        });

        // ============================
        // GARANTÍA
        // ============================
        const gar = data.garantias?.[0];
        if (gar) {
          setGarantia({
            descripcion: gar.descripcion || "",
            serie: gar.serie || ""
          });
          setIdGarantia(gar.id_garantia);
        }

        // ============================
        // COMPROBANTES (CLIENTE + AVALES)
        // ============================
        const compsCliente = data.comprobantes_cliente || {};
        const compsAval1 = data.avales?.[0]?.comprobantes || {};
        const compsAval2 = data.avales?.[1]?.comprobantes || {};

        const archivosIniciales = {
          // CLIENTE
          ine: compsCliente.ine,
          domicilio: compsCliente.domicilio,
          contrato: compsCliente.contrato,
          pagare: compsCliente.pagare,
          video: compsCliente.video,
          red: compsCliente.red,
          garantia: compsCliente.garantia,

          // AVAL 1
          aval1_ine: compsAval1.ine,
          aval1_domicilio: compsAval1.domicilio,

          // AVAL 2
          aval2_ine: compsAval2.ine,
          aval2_domicilio: compsAval2.domicilio
        };

        setArchivos(archivosIniciales);

      } catch (err) {
        console.error(err);
        alert("Error al cargar los datos del cliente");
      } finally {
        setCargando(false);
      }
    };
    cargarCliente(clienteId);
  }, [clienteId, esVer, esEditar, estados, ciudades]);

  // ============================
  // CANCELAR
  // ============================
  const cancelar = () => navigate("/clientes");

  // ============================
  // TÍTULO DINÁMICO
  // ============================
  const titulo = esCrear
    ? "Crear Cliente"
    : esEditar
    ? "Editar Cliente"
    : "Ver Cliente";

  // ============================
  // RENDER
  // ============================
  if (cargando) {
    return (
      <div className="crear-container">
        <p style={{ padding: "2rem", textAlign: "center" }}>
          Cargando datos del cliente...
        </p>
      </div>
    );
  }

  // ============================
  // CAMPOS DE DATOS GENERALES (MAP)
  // ============================
  const camposGenerales = [
    { label: "Nombres", name: "Nombre" },
    { label: "Apellido Paterno", name: "Apellido_Paterno" },
    { label: "Apellido Materno", name: "Apellido_Materno" },
    { label: "Dirección", name: "Direccion" },
    {
      label: "Código Postal",
      name: "Codigo_postal",
      onChange: handleCPChange
    },
    {
      label: "Teléfono",
      name: "telefono",
      onChange: handleTelefono
    },
    { label: "Email", name: "email" },
    { label: "Ubicación", name: "Ubicacion" },
    { label: "Facebook", name: "Facebook" }
  ];

  // ============================
  // COMPROBANTES DEL CLIENTE (MAP)
  // ============================
  const comprobantesCliente = [
    { key: "domicilio", label: "Comprobante de domicilio" },
    { key: "ine", label: "INE" },
    { key: "video", label: "Comprobante video" },
    { key: "red", label: "Comprobante red social" },
    { key: "contrato", label: "Contrato firmado" },
    { key: "pagare", label: "Pagaré" },
    { key: "garantia", label: "Garantía", isGarantia: true }
  ];

  // ============================
  // RENDER PRINCIPAL
  // ============================
  return (
    <div className="crear-container">
      {/* ENCABEZADO */}
      <div className="crear-header">
        <h2>{titulo}</h2>

        <div className="acciones-header">
          <button className="btn-header btn-cancelar" onClick={cancelar}>
            {esVer ? "Regresar" : "Cancelar"}
          </button>

          {esVer && (
            <button
              className="btn-header btn-guardar"
              onClick={() => navigate(`/clientes/${clienteId}/editar`)}
            >
              Editar
            </button>
          )}

          {esCrear && fase === 1 && (
            <button className="btn-header btn-guardar" onClick={guardarCliente}>
              Guardar Cliente
            </button>
          )}

          {esEditar && (
            <button className="btn-header btn-guardar" onClick={guardarCliente}>
              Actualizar Cliente
            </button>
          )}
        </div>
      </div>

      {/* DATOS GENERALES */}
      <div className="form-card">
        <div className="datos-header">
          <h3>Datos Generales</h3>

          <div className="header-opciones">
            {/* SWITCH ACTIVO */}
            <div
              className="switch-container"
              onClick={() =>
                !soloLectura &&
                updateForm("activo", form.activo === 1 ? 0 : 1)
              }
              style={{ cursor: soloLectura ? "default" : "pointer" }}
            >
              <div className={`switch ${form.activo === 1 ? "on" : "off"}`}>
                <span className="switch-label">
                  {form.activo === 1 ? "Activo" : "Inactivo"}
                </span>
              </div>
            </div>

            {/* SEMÁFORO */}
            <div
              className="semaforo-switch"
              onClick={() => {
                if (soloLectura) return;
                const next =
                  form.semaforo === "verde"
                    ? "amarillo"
                    : form.semaforo === "amarillo"
                    ? "rojo"
                    : "verde";
                updateForm("semaforo", next);
              }}
              style={{ cursor: soloLectura ? "default" : "pointer" }}
            >
              <div className={`semaforo-circle ${form.semaforo}`}></div>
              <span className="semaforo-text">
                {form.semaforo === "verde"
                  ? "Confiable"
                  : form.semaforo === "amarillo"
                  ? "Riesgo medio"
                  : "Riesgo alto"}
              </span>
            </div>

            {/* SWITCH TIPO CLIENTE */}
           <div
              className="switch-tipo"
              onClick={() => {
                const orden = ["semanal", "diario", "ambos"];
                const idx = orden.indexOf(form.tipo_cliente);
                const siguiente = orden[(idx + 1) % orden.length];

                setForm({ ...form, tipo_cliente: siguiente });
              }}
            >
              <div className={`switch-tipo-inner ${form.tipo_cliente}`}>
                <span className="switch-tipo-label">
                  {form.tipo_cliente === "semanal"
                    ? "Semanal"
                    : form.tipo_cliente === "diario"
                    ? "Diario"
                    : "Ambos"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* FORMULARIO GENERAL */}
        <div className="form-grid">
          {camposGenerales.map(c => (
            <div key={c.name}>
              <label>{c.label}</label>
              <input
                type="text"
                name={c.name}
                value={form[c.name]}
                onChange={c.onChange || handleChange}
                disabled={soloLectura}
              />
            </div>
          ))}

          {/* ESTADO */}
          <div>
            <label>Estado</label>
            <select
              name="estado_id"
              value={form.estado_id}
              onChange={handleEstadoChange}
              disabled={soloLectura}
            >
              <option value="">Seleccione...</option>
              {estados.map(e => (
                <option key={e.id} value={e.id}>
                  {e.nombre}
                </option>
              ))}
            </select>
          </div>

          {/* CIUDAD */}
          <div>
            <label>Ciudad</label>
            <select
              name="ciudad_id"
              value={form.ciudad_id}
              onChange={handleChange}
              disabled={soloLectura}
            >
              <option value="">Seleccione...</option>
              {ciudadesFiltradas.map(c => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
            </select>
          </div>

          {/* GRUPO */}
          <div>
            <label>Grupo</label>
            <select name="grupo_id" value={form.grupo_id} disabled>
              <option value="">Seleccione...</option>
              {grupos.map(g => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </select>
          </div>

          {/* ASESOR */}
          <div>
            <label>Asesor</label>
            <select
              name="asesor_id"
              value={form.asesor_id}
              onChange={handleAsesorChange}
              disabled={soloLectura}
            >
              <option value="">Seleccione...</option>
              {asesores.map(a => (
                <option key={a.id} value={a.id}>
                  {a.alias}
                </option>
              ))}
            </select>
          </div>

          {/* CRÉDITO */}
          <div>
            <label>Crédito aceptado</label>
            <input
              type="text"
              name="credito_aceptado"
              value={form.credito_aceptado}
              onChange={handleCredito}
              disabled={soloLectura}
            />
          </div>
        </div>
      </div>
      {/* ===================== FASE 2 / VIEW / EDIT ===================== */}
      {mostrarFase2 && (
        <>
          {/* AVALES */}
          <div className="form-card">
            <h3>Avales</h3>

            {/* AVAL 1 */}
            <div className="form-grid">
              <div>
                <label>Nombre Aval 1</label>
                <input
                  type="text"
                  name="nombre"
                  value={avales.aval1.nombre}
                  onChange={(e) => handleAvalChange(e, "aval1")}
                  disabled={soloLectura}
                />
              </div>

              <div>
                <label>Parentesco Aval 1</label>
                <select
                  name="parentesco"
                  value={avales.aval1.parentesco}
                  onChange={(e) => handleAvalChange(e, "aval1")}
                  disabled={soloLectura}
                >
                  <option value="">Seleccione...</option>
                  {parentescos.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>

              <div>
                <label>Facebook Aval 1</label>
                <input
                  type="text"
                  name="facebook"
                  value={avales.aval1.facebook}
                  onChange={(e) => handleAvalChange(e, "aval1")}
                  disabled={soloLectura}
                />
              </div>

              <div>
                <label>Teléfono Aval 1</label>
                <input
                  type="text"
                  name="telefono"
                  value={avales.aval1.telefono}
                  onChange={(e) => handleTelefonoAval(e, "aval1")}
                  disabled={soloLectura}
                />
              </div>
            </div>

            {!soloLectura && (
              <div className="comprobantes-grid aval-comprobantes">

                {/* DOMICILIO AVAL 1 */}
                <div className="comprobante-item">
                  <button
                    className={archivos["aval1_domicilio"] ? "btn-subido" : ""}
                    onClick={() => setModal("aval1_domicilio")}
                  >
                    Comprobante domicilio
                  </button>
                </div>

                {/* INE AVAL 1 */}
                <div className="comprobante-item">
                  <button
                    className={archivos["aval1_ine"] ? "btn-subido" : ""}
                    onClick={() => setModal("aval1_ine")}
                  >
                    INE
                  </button>
                </div>

              </div>
            )}

            <hr />

            {/* AVAL 2 */}
            <div className="form-grid">
              <div>
                <label>Nombre Aval 2</label>
                <input
                  type="text"
                  name="nombre"
                  value={avales.aval2.nombre}
                  onChange={(e) => handleAvalChange(e, "aval2")}
                  disabled={soloLectura}
                />
              </div>

              <div>
                <label>Parentesco Aval 2</label>
                <select
                  name="parentesco"
                  value={avales.aval2.parentesco}
                  onChange={(e) => handleAvalChange(e, "aval2")}
                  disabled={soloLectura}
                >
                  <option value="">Seleccione...</option>
                  {parentescos.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>

              <div>
                <label>Facebook Aval 2</label>
                <input
                  type="text"
                  name="facebook"
                  value={avales.aval2.facebook}
                  onChange={(e) => handleAvalChange(e, "aval2")}
                  disabled={soloLectura}
                />
              </div>

              <div>
                <label>Teléfono Aval 2</label>
                <input
                  type="text"
                  name="telefono"
                  value={avales.aval2.telefono}
                  onChange={(e) => handleTelefonoAval(e, "aval2")}
                  disabled={soloLectura}
                />
              </div>
            </div>

            {!soloLectura && (
              <div className="comprobantes-grid aval-comprobantes">

                {/* DOMICILIO AVAL 2 */}
                <div className="comprobante-item">
                  <button
                    className={archivos["aval2_domicilio"] ? "btn-subido" : ""}
                    onClick={() => setModal("aval2_domicilio")}
                  >
                    Comprobante domicilio
                  </button>
                </div>

                {/* INE AVAL 2 */}
                <div className="comprobante-item">
                  <button
                    className={archivos["aval2_ine"] ? "btn-subido" : ""}
                    onClick={() => setModal("aval2_ine")}
                  >
                    INE
                  </button>
                </div>

              </div>
            )}

            {!soloLectura && (
              <button className="btn-guardar" onClick={guardarAvales}>
                {esEditar ? "Actualizar Avales" : "Guardar Avales"}
              </button>
            )}
          </div>


          {/* GARANTÍA */}
          <div className="form-card">
            <h3>Garantía</h3>

            <div className="form-grid">
              <div>
                <label>Descripción</label>
                <input
                  type="text"
                  name="descripcion"
                  value={garantia.descripcion}
                  onChange={e =>
                    !soloLectura &&
                    setGarantia({ ...garantia, descripcion: e.target.value })
                  }
                  disabled={soloLectura}
                />
              </div>

              <div>
                <label>Serie</label>
                <input
                  type="text"
                  name="serie"
                  value={garantia.serie}
                  onChange={e =>
                    !soloLectura &&
                    setGarantia({ ...garantia, serie: e.target.value })
                  }
                  disabled={soloLectura}
                />
              </div>
            </div>

            {!soloLectura && (
              <button className="btn-guardar btn-guardar-garantia" onClick={guardarGarantia}>
                {esEditar ? "Actualizar Garantía" : "Guardar Garantía"}
              </button>
            )}
          </div>

          {/* COMPROBANTES CLIENTE */}
          {!soloLectura && (
            <div className="comprobantes-card">
              <h3>Comprobantes del Cliente</h3>

              <div className="comprobantes-grid">
                {comprobantesCliente.map(c => (
                  <div key={c.key} className="comprobante-item">
                    <button
                      className={archivos[c.key] ? "btn-subido" : ""}
                      onClick={() => {
                        if (c.isGarantia && !idGarantia) {
                          return alert("Primero guarda la garantía antes de subir la foto.");
                        }
                        c.isGarantia ? setShowModalGarantia(true) : setModal(c.key);
                      }}
                    >
                      {c.label}
                    </button>
                  </div>
                ))}
              </div>

              <button className="btn-guardar" onClick={guardarComprobantes}>
                Guardar Comprobantes
              </button>
            </div>
          )}
        </>
      )}

      {/* MODAL FOTO GARANTÍA */}
      {showModalGarantia && (
        <ModalArchivo
          tipo="garantia"
          titulo="Subir foto de garantía"
          archivosExistentes={
            Array.isArray(archivos.garantia)
              ? archivos.garantia
              : archivos.garantia
              ? [archivos.garantia]
              : []
          }
          onUpload={(files) => {
            setArchivos(prev => ({
              ...prev,
              garantia: Array.isArray(prev.garantia)
                ? [...prev.garantia, files]
                : [files]
            }));
            setShowModalGarantia(false);
          }}
          // 🔥 ESTA ES LA LÍNEA QUE FALTABA 🔥
          onGuardar={({ tipo, nuevos, eliminar }) => {
          handleModalComprobantesSave(tipo, { nuevos, eliminar });
          setShowModalGarantia(false);
    }}
          onClose={() => setShowModalGarantia(false)}
        />
      )}


      {/* MODAL GENERAL COMPROBANTES */}
      {modal && (
        <ModalArchivo
          tipo={modal}
          titulo={
            modal === "domicilio"
              ? "Subir comprobante de domicilio"
              : modal === "ine"
              ? "Subir INE"
              : modal === "video"
              ? "Subir comprobante de video"
              : modal === "red"
              ? "Subir comprobante de red social"
              : modal === "Contrato"
              ? "Subir contrato firmado"
              : modal === "Pagare"
              ? "Subir pagaré firmado"
              : modal === "aval1_domicilio"
              ? "Subir comprobante domicilio Aval 1"
              : modal === "aval1_ine"
              ? "Subir INE Aval 1"
              : modal === "aval2_domicilio"
              ? "Subir comprobante domicilio Aval 2"
              : modal === "aval2_ine"
              ? "Subir INE Aval 2"
              : "Subir archivo"
          }

          // Archivos existentes
          archivosExistentes={
            Array.isArray(archivos[modal])
              ? archivos[modal]
              : archivos[modal]
              ? [archivos[modal]]
              : []
          }

          onGuardar={({ tipo, nuevos, eliminar }) => {
            handleModalComprobantesSave(tipo, { nuevos, eliminar });
            setModal(null);
          }}

          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
